import {assert} from 'assert-ts';
import type {Metadata} from '../types';

export function getExpressionWorkId(data: Metadata, expressionId: string) {
  const workId = data.expressions.find(m => m.id === expressionId)?.workId;
  return assert(workId, 'getExpressionWorkId: unknown expressionId', {
    expressionId,
  });
}
